import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Person} from "../../../services/interface/query/person";
import NotPermissionComponent from "../NotPermissionComponent";
import CustomTable, {TypeItemTable} from "../../../components/general/CustomTable";
import {useFindCorporateInvestments} from "../../../services/apis/apiProperties";
import {getMessageGeneric} from "../../../services/configuration/errorHandle";
import {CorporateInvestmentInterface} from "../../../services/interface/query/corporate-investment-interface";
import IdentificationConsult from "../../terms-conditions/IdentificationConsult";
import {formatDateHoursString} from "../../../utils/daysOptions";
import InfoOnline from "../../components/InfoOnline";

interface Props {
    person?: Person;
}

export default function CorporateInvestments({person}: Props): JSX.Element {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findCorporateInvestments,
        data: successFindCorporateInvestments,
        isPending: loadingFindCorporateInvestments,
        error: errorFindCorporateInvestments,
    } = useFindCorporateInvestments()

    const [response, setResponse] = React.useState<CorporateInvestmentInterface[] | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()

    useEffect(() => {
        if (person && person.identification) {
            setResponse(undefined)
            setListElement(undefined)
            findCorporateInvestments({identifier: person.identification, msj: t('corporate-investments')})
        }
    }, [person]);

    useEffect(() => {
        if (successFindCorporateInvestments) {
            setResponse(successFindCorporateInvestments)
        }
    }, [successFindCorporateInvestments]);

    useEffect(() => {
        if (response && response.length > 0) {
            setListElement(response.map(item => ({
                row: [
                    <IdentificationConsult
                        className={'text-header text-[14px] pl-2'}
                        identification={item?.identificacion}
                    />,
                    item.nombre,
                    item.situacionLegal,
                    item.capital,
                    formatDateHoursString(item.fechaActualizacion)
                ]
            })))
        }
    }, [response]);

    return (
        <div className={'flex flex-col gap-3'}>
            <div className={'flex flex-row gap-2'}>
                <h3 className={'capitalize'}>{t('corporate-investments')}</h3>
                <InfoOnline
                    onClick={() => {
                        if (person?.identification) {
                            setResponse(undefined)
                            setListElement(undefined)
                            findCorporateInvestments({
                                identifier: person.identification,
                                msj: t('corporate-investments')
                            })
                        }
                    }}
                />
            </div>
            <NotPermissionComponent
                title={'/income/current'}
                loading={loadingFindCorporateInvestments}
                error={errorFindCorporateInvestments}
                component={
                    <>
                        <CustomTable
                            loading={loadingFindCorporateInvestments}
                            error={getMessageGeneric(errorFindCorporateInvestments, '/property_assets/corporateInvestments')}
                            header={[
                                t(''),
                                t('company'),
                                t('situation'),
                                t('capital'),
                                t('date-update'),
                            ]}
                            {...{listElement}}
                        />
                    </>
                }
            />
        </div>
    )
}
